module.exports = __webpack_public_path__ + "static/media/nomics.4050dda8.svg";